<script lang="ts">
  import type { Component } from "svelte";
  import { onMount } from "svelte";

  import { resolveAppConfig } from "./lib/config";
  import { router, type Section } from "./lib/router.svelte";
  import { Spinner, Toaster } from "./lib/ui";
  import SiteShell from "./route/site/SiteShell.svelte";

  // Admin and remote ship as separate lazily-loaded chunks so neither is
  // in the initial public bundle (defense-in-depth for the admin console;
  // authorization is enforced server-side on /v1/admin/* regardless).
  const lazy: Record<Exclude<Section, "site">, () => Promise<{ default: Component }>> = {
    admin: () => import("./route/admin/AdminShell.svelte"),
    remote: () => import("./route/remote/RemoteShell.svelte"),
  };

  let section = $derived(router.section);

  onMount(() => {
    router.start();
    // Warm the runtime-config cache so the first sign-in tap doesn't
    // wait on a network round-trip. Failure here is non-fatal — the
    // call that *needs* config (sign-in, sign-out, gate probe) will
    // re-throw with a clear AppConfigUnavailableError the caller can
    // surface to the user. Just log so we don't drop an unhandled
    // rejection on the console.
    resolveAppConfig().catch((err) => {
      console.warn("[app] runtime config warmup failed:", err);
    });
  });
</script>

{#if section === "site"}
  <SiteShell />
{:else}
  {#await lazy[section]()}
    <div class="console-bg flex min-h-screen items-center justify-center">
      <Spinner size={22} label="Loading…" />
    </div>
  {:then mod}
    <mod.default />
  {:catch}
    <div class="console-bg flex min-h-screen items-center justify-center text-ink-dim">
      Failed to load this section. Try refreshing.
    </div>
  {/await}
{/if}

<Toaster />
